import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '@hooks/useAction';
import { useFollowingIdReference } from './useFollowingIdReference';
import { useMemo } from 'react';
export function useUpdateFollowing(sonarObjectIds = []) {
    const following = useFollowingIdReference();
    const follow = useAction(coreActions.requestPostCoreFollow);
    const unfollow = useAction(coreActions.requestPostCoreUnfollow);
    const { followed, unfollowed } = useMemo(() => {
        const result = {
            followed: [],
            unfollowed: []
        };
        for (const sonarObjectId of sonarObjectIds) {
            if (following === null || following === void 0 ? void 0 : following[sonarObjectId]) {
                result.followed.push(sonarObjectId);
            }
            else {
                result.unfollowed.push(sonarObjectId);
            }
        }
        return result;
    }, [following, sonarObjectIds]);
    return {
        follow: (ids) => follow({ sonarObjectIds: ids !== null && ids !== void 0 ? ids : unfollowed }),
        followed,
        unfollow: (ids) => unfollow({ sonarObjectIds: ids !== null && ids !== void 0 ? ids : followed }),
        unfollowed
    };
}
